import { useProvider } from "@adobe/react-spectrum";
import { useEffect, useState } from "react";

type HostInfo = {
  isMobile: boolean;
  isDesktop: boolean;
  isStandAlone: boolean;
  isIPadAir: boolean;
  isIPadPro: boolean;
  OS: string;
};
export function useViewInfo(): HostInfo {
  const provider = useProvider();
  const [isMobile, setIsMobile] = useState(
    provider.breakpoints.M! > window.innerWidth,
  );
  const [isDesktop, setIsDesktop] = useState(
    provider.breakpoints.M! <= window.innerWidth,
  );
  const [isIPadAir, setIsIPadAir] = useState(
    (window.innerWidth === 820 && window.innerHeight === 1180) ||
      (window.innerWidth === 1180 && window.innerHeight === 820),
  );
  /** iPad pro 13 inch */
  const [isIPadPro, setIsIPadPro] = useState(
    (window.innerWidth === 1032 && window.innerHeight === 1376) ||
      (window.innerWidth === 1376 && window.innerHeight === 1032),
  );
  const [OS, setOS] = useState("");
  const isStandAlone =
    window.matchMedia("(display-mode: standalone)").matches ||
    document.referrer.includes("android-app://");

  useEffect(() => {
    setIsMobile(provider.breakpoints.M! > window.innerWidth);
    setIsDesktop(provider.breakpoints.M! <= window.innerWidth);
    setIsIPadAir(
      (window.innerWidth === 820 && window.innerHeight === 1180) ||
        (window.innerWidth === 1180 && window.innerHeight === 820),
    );
    setIsIPadPro(
      (window.innerWidth === 1032 && window.innerHeight === 1376) ||
        (window.innerWidth === 1376 && window.innerHeight === 1032),
    );
  }, [provider.breakpoints.M, window.innerWidth, window.innerHeight]);

  useEffect(() => {
    if (window.navigator.userAgent.includes("Android")) {
      setOS("Android");
    } else if (window.navigator.userAgent.includes("iOS")) {
      setOS("iOS");
    } else if (window.navigator.userAgent.includes("Windows")) {
      setOS("Windows");
    } else if (window.navigator.userAgent.includes("Mac")) {
      setOS("Mac");
    } else if (window.navigator.userAgent.includes("Linux")) {
      setOS("Linux");
    } else {
      setOS("Unknown");
    }
  }, []);
  return {
    isMobile,
    isDesktop,
    isStandAlone,
    isIPadAir,
    isIPadPro,
    OS,
  };
}
